import "../../../css/buttons/PrimaryButton.css";


const scrollToContact = () => {
  document
    .getElementById("contact-us")
    ?.scrollIntoView({ behavior: "smooth", block: "start" });
};

const PrimaryButtonSmall = ({ onClick, text }) => {
  const handleClick =
    onClick || scrollToContact;

  return (
    <button type="button" className="primary-button" onClick={handleClick}>
      <div className="button-text-small">{text}</div>
    </button>
  );
};

export default PrimaryButtonSmall;
